import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import * as comMod from '../../commonModule';
import { setBillInfoToSch } from '../Billing/blMakeData';
import teal from '@material-ui/core/colors/teal';
import { checkConvertJido } from './ConvJido';

const useStyles = makeStyles({
  invoiceHead:{
    display:'flex',
    justifyContent: 'space-between',
    marginTop: 60,
    '& .left' :{
      width: '35%',
    },
    '& .right' : {
      width:'35%',
      textAlign: 'right',
    },
    '& .center':{
      width: '30%',
    },
    '& >div>div' : {
      padding: '4px 0',
    },
    '& .large' : {
      fontSize: '1.4rem',
      padding: '6px 0',
    },
    '& .tall': {
      padding: '6px 0',
    },
    '& .small': {
      padding: '2px 0',
      fontSize: '.8rem'
    },
    '& .title': {
      padding: '12px 0 6px',
      fontSize: '2.2rem',
      textAlign:'center',
      color: teal[900],
    },
    '& .date': {
      marginBottom: 8,
    },
  },
  comment: {
    marginTop: '-32px',
  },
  total: {
    fontSize: '1.2rem',
    padding: '8px 0 2px',
    borderBottom: '2px solid' + teal[600],
    display:'flex',
    justifyContent: 'space-between',
    width: '60%',
    marginTop:16,
  },
  invtbl:{
    width: '100%',
    marginTop:16,
    '& td ' : {
      padding: '12px 8px 8px',
    },
    '& .notice':{
      minWidth: "120px"
    },
    '& td.num': {
      textAlign: 'right',
    },
    '& .title': {
      textAlign: 'center',
      borderBottom: '1px solid' + teal[600],
      borderTop: '1px solid' + teal[600],
    },
    '& .tblDetail': {
      height: 36,
    },
    '& .tblDetail:nth-of-type(even)': {
      backgroundColor: teal[50],
    },
    '& .total': {
      borderBottom: '2px solid' + teal[600],
      borderTop: '1px solid' + teal[600],
    },
  },
  reportsNotice: {
    marginTop: 16,
    lineHeight: '1.5rem',
    whiteSpace: 'pre-wrap',
  }
});

const acCostDetaiSort = (thisBdt, com, config) => {
  // 初期値の実費項目
  let acConstDef = comMod.findDeepPath(com, 'etc.actualCostList');
  acConstDef = acConstDef? acConstDef: config.actualCostList;
  if (!thisBdt.actualCostDetail) return false;
  if (!thisBdt.actualCostDetail.length) return false;
  thisBdt.actualCostDetail.sort((a, b)=>{
    if (acConstDef[a.name]) return -1;
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
  });

}

const OnePageOfInvoiceWithCopy = (props) => {
  const classes = useStyles();
  const {
    thisBdt, userList, users, stdDate, com, service, preview, rowLength, ...others
  } = props
  const config = useSelector(state=>state.config);
  const schedule = useSelector(state=>state.schedule);

  //橋本追加
  const comEtc = com.etc ?com.etc :{};
  const displayDate = comMod.findDeepPath(
    comEtc, 'configReports.invoice.displayDate'
  )
  const displayNotice = comMod.findDeepPath(
    comEtc, 'configReports.invoice.displayNotice'
  )
  //橋本追加 11/17
  const reports_notice = comMod.findDeepPath(
    comEtc, 'reports.invoice.notice'
  )

  const convJido = checkConvertJido(com);

  const thisUser = comMod.getUser(thisBdt.UID, users);
  const preview_list = [];
  if(preview === "請求書控え付き"){
    preview_list.push("請求書");
    preview_list.push("請求書控え");
  }else if(preview === "受領書控え付き"){
    preview_list.push("受領書");
    preview_list.push("受領書控え");
  }
  const invoiceWithCopyNodes =  preview_list.map(preview => {
    let title = preview;
    let comment;
    if (title.indexOf('請求書') > -1){
      comment = '下記の通りご請求申し上げます。ご確認いただけますようお願い申し上げます。';
    }
    else if (title.indexOf('受領書') > -1){
      comment = '下記、正に受領致しました。';
    }
    const stateDate = comMod.findDeepPath(
      schedule, ['report', service, '請求書受領書']
    );
    //橋本追加
    let invoiceDate = stateDate
    ? stateDate: comMod.formatDate(new Date(), 'YYYY年MM月DD日');
    invoiceDate = displayDate ?invoiceDate :"　　　　年　　月　　日";
    // 合計値計算と文字列変換
    let grandTotal = 0;
    thisBdt.actualCostDetail.map(e=>{grandTotal += e.price});
    grandTotal += thisBdt.kanrikekkagaku;
    grandTotal -= comMod.null2Zero(thisBdt.jichiJosei);
    if (!grandTotal) return null;
    const grandTotalStr = '￥' + comMod.formatNum(grandTotal, 1) + '-';
    const invoiceHead = (<>
      <div className={classes.invoiceHead}>
        <div className='left'>
          <div className='large'>{thisUser.pname} 様</div>
          <div>{thisUser.hno + ' ' + thisUser.name} 様</div>
          <div>{stdDate.substr(0, 4) + '年' + stdDate.substr(5, 2) + '月分'}</div>
        </div>
        <div className='center'>
        <div className='title'>{title}</div>
        </div>
        <div className='right'>
          <div className='date'>{invoiceDate}</div>
          <div>{com.hname}</div>
          <div>{com.bname}</div>
          <div className='small'>{com.postal} {com.city}</div>
          <div className='small'>{com.address}</div>
          <div>TEL:{com.tel}</div>
        </div>
      </div>
      <div className={classes.comment}>{comment}</div>
      <div className={classes.total}>
        <div className='str'>合計額</div>
        <div className='num'>{grandTotalStr}</div>
      </div>
    </>)
    const tabelTitle = (<>
      <tr className='title'>
        <td>項番</td>
        <td>項目</td>
        <td>単価</td>
        <td>数量</td>
        <td>金額</td>
        <td className='notice'>備考</td>
      </tr>
    </>);
    const rowArray = Array(reports_notice ?8 :rowLength).fill('');
    acCostDetaiSort(thisBdt, com, config);
    // 2022/02/09 自治体助成反映
    const tabeleAcRows = rowArray.map((e,i)=>{
      const tdContent = (key) =>(
        (i < thisBdt.actualCostDetail.length)? 
          (isNaN(thisBdt.actualCostDetail[i][key])) ?
            thisBdt.actualCostDetail[i][key] : 
            comMod.formatNum(thisBdt.actualCostDetail[i][key], 1):''
      )
      return(
        <tr className='tblDetail' key={i}>
          <td className='num'>
            {
              (i < thisBdt.actualCostDetail.length) ? (i + 2) : " "
            }
          </td>
          <td>{tdContent('name')}</td>
          <td className='num'>{tdContent('unitPrice')}</td>
          <td className='num'>{tdContent('count')}</td>
          <td className='num'>{tdContent('price')}</td>
          <td className='notice'>{displayNotice ?"" :""}</td>
        </tr>
      )
    });
    const TableJikofutanRow = () => {
      const futangaku = 
      thisBdt.kanrikekkagaku - comMod.null2Zero(thisBdt.jichiJosei);
      return(
        <tr className='tblDetail'>
          <td className='num'>1</td>
          <td>
            {
              (thisUser.service === '放課後等デイサービス') ?
              (convJido ?'児童':'障害児')+'通所給付費利用者負担額' : (convJido ?'児童':'障害児')+'発達支援給付費利用者負担額'
            }
          </td>
          <td className='num'>{comMod.formatNum(futangaku, 1)}</td>
          <td className='num'>1</td>
          <td className='num'>{comMod.formatNum(futangaku, 1)}</td>
          <td className='notice'>{displayNotice ?"ご利用回数"+thisBdt.countOfUse+"回" :""}</td>
        </tr>
      )
    }

    const tableTotalRow = (
      <tr className='total'>
        <td></td>
        <td>合計</td>
        <td></td>
        <td></td>
        <td className='num'>{comMod.formatNum(grandTotal, 1)}</td>
        <td className='notice'>{displayNotice ?"" :""}</td>
      </tr>
    )

    return(
      <div>
        {invoiceHead}
        <table className={classes.invtbl}>
          <tbody>
          {tabelTitle}
          <TableJikofutanRow/>
          {tabeleAcRows}
          {tableTotalRow}
          </tbody>
        </table>
        {reports_notice
          ?<div className={classes.reportsNotice}>
            {comMod.brtoLf(reports_notice)}
          </div>:null
        }
      </div>
    )
  })

  if(!(invoiceWithCopyNodes[0] || invoiceWithCopyNodes[1])) return null;
  return (
    <div className='printPage'>
      {invoiceWithCopyNodes[0]}
      <div style={{marginTop: reports_notice ?"180px" :"150px"}}></div>
      {invoiceWithCopyNodes[1]}
      <div className={'pageBreak'}></div>
    </div>
  )
}

export default (props) => {
  const rowLength = 10; //行の長さ
  const nameList = ['請求書控え付き', '受領書控え付き'];
  const {userList, preview, ...others} = props;
  const stdDate = useSelector(state => state.stdDate);
  const schedule = useSelector(state => state.schedule);
  const users = useSelector(state => state.users);
  const com = useSelector(state => state.com);
  const serviceItems = useSelector(state => state.serviceItems);
  const service = useSelector(state => state.service);
  const prms = { stdDate, schedule, users, com, service, serviceItems };
  // リストにないプレビューが送られてきたら何もしないで終了
  if (nameList.indexOf(preview) < 0)  return null;
  const { billingDt } = setBillInfoToSch(prms);

  const rowLengthError =  billingDt.map(billing => {
    const actualCostDetail = billing["actualCostDetail"];
    if(actualCostDetail.length+1 <= rowLength) return true;
    return false
  })
  let rowLengthErrorMaxWidth = 0;
  const canvas = document.createElement('canvas').getContext('2d');
  canvas.font = '18.5px \'Noto Sans\', sans-serif';
  if(rowLengthError.some(x => x === false)){
    const rowLengthErrorUsers =rowLengthError.map((x,index) => {
      if(x) return false;
      const userDt = billingDt[index];
      const userName = userDt["name"];
      const hno = userDt["hno"];
      const actualCostDetailLength = userDt["actualCostDetail"].length+1;
      const width = Math.ceil(canvas.measureText(userName).width);
      if(width > rowLengthErrorMaxWidth) rowLengthErrorMaxWidth = width
      return(
        <div style={{display: "flex", margin:"8px 0"}}>
          <div style={{width: rowLengthErrorMaxWidth+"px"}}>{userName}</div>
          <div>({hno})</div>
          <div style={{marginLeft:"10px", color: "#b71c1c", fontWeight: "bold"}}>{actualCostDetailLength}/{rowLength}</div>
        </div>
      )
    }).filter(x => x);
    return(
      <div style={{marginTop: '150px'}}>
        <div style={{marginBottom:"5px"}}>
          実費項目数が多すぎるためこの書式では出力できません。他の書式を選択して下さい。
        </div>
        {rowLengthErrorUsers}
      </div>
    )
  }
  const c_users = [...users];
  c_users.sort((a, b)=> a.sindex - b.sindex);
  const pagesOfInvoiceWithCopy = c_users.map((e, i)=>{
    // ユーザーリストにないデータはスキップ
    if (!userList.find(f => f.uid === e.uid))  return null;
    // ユーザーリストでチェックにないデータはスキップ
    if (!userList.find(f => f.uid === e.uid).checked) return null;
    const thisBdt = billingDt.find(f=>f.UID === 'UID' + e.uid);
    if (!thisBdt) return null;
    const oneProps = {
      thisBdt, userList, users, stdDate, com, service , preview, rowLength
    }
    return( 
      <OnePageOfInvoiceWithCopy {...oneProps} key={i}/>
    ) 
  });

  return pagesOfInvoiceWithCopy;
}